import { useQuery } from "react-query";
import { getExistence } from "@/api/Products/Existences/existence-query";

const queryKeyRoot = "existences";

function normalizeInventoryId(inventoryIdentifier) {
	if (inventoryIdentifier === undefined || inventoryIdentifier === null || inventoryIdentifier === "undefined") {
		return "";
	}

	return String(inventoryIdentifier);
}

function normalizeFilterValue(filterValue) {
	if (Array.isArray(filterValue)) {
		return filterValue
			.map(String)
			.sort((firstValue, secondValue) => firstValue.localeCompare(secondValue))
			.join(",");
	}

	if (filterValue === undefined || filterValue === null) {
		return "";
	}

	return String(filterValue);
}

export function useExistence(params) {
	const {
		type,
		product_id: productIdentifier,
		inventory_id: inventoryIdentifier,
		option,
		estate_parent_id: estateParentIdentifier,
		estate_id: estateIdentifier,
	} = params;

	const normalizedInventoryId = normalizeInventoryId(inventoryIdentifier);
	const normalizedEstateParentIds = normalizeFilterValue(estateParentIdentifier);
	const normalizedEstateIds = normalizeFilterValue(estateIdentifier);

	const isProductIdentifierDefined = productIdentifier !== "" && productIdentifier !== undefined && productIdentifier !== "undefined";
	const isMovementsOptionSelected = option === "movimientos";
	const isQueryEnabled = isProductIdentifierDefined && isMovementsOptionSelected;

	return useQuery(
		[queryKeyRoot, type ?? "", String(productIdentifier ?? ""), normalizedInventoryId, normalizedEstateParentIds, normalizedEstateIds],
		() =>
			getExistence({
				ID_PRODUCT: productIdentifier,
				ID_INVENTORY: normalizedInventoryId,
				type,
				estate_parent_id: estateParentIdentifier,
				estate_id: estateIdentifier,
			}),
		{
			enabled: isQueryEnabled,
			refetchOnWindowFocus: false,
			refetchInterval: false,
			staleTime: Infinity,
		},
	);
}
